export function getThirtyDaysProps(
  goal: Record<string, any>, investment_goal_type_id: string, target_date: string,
) {
  return {
    investorGoalId: goal.id,
    investmentGoalTypeId: investment_goal_type_id,
    goalName: goal.goal_name,
    monthlyContribution: goal.monthly_required_amount,
    targetAmount: goal.accumulated_amount,
    targetDate: target_date,
    term: goal.fixed_time_adjusted,
  };
}
